export default "__VITE_ASSET__CA3$30oo__"